<div class="celebration-content">
  <ng-container *ngIf="socialChallengeBloc.celebrationModalChallenge$ | async as challenge">
    <h2 class="celebration-title">{{ challenge.title }} Challenge</h2>
    <kf-sc-social-challenge-progress
      class="celebration-paths"
      [groupGoal]="challenge.group.goal"
      [initGroupProgress]="challenge.group.status.progress.count / 2"
      [groupProgress]="challenge.group.status.progress.count"
      [individualGoal]="challenge.individual.goal"
      [initIndividualProgress]="challenge.individual.status.progress.count - 1"
      [individualProgress]="challenge.individual.status.progress.count"
      [centerPathRef]="centerPath.EMPTY"
      [isOnBackground]="true"></kf-sc-social-challenge-progress>
    <h3 class="celebration-objective">
      {{ challenge.individual.status.progress.count }} {{ challenge.objective }} Completed!
    </h3>
  </ng-container>
</div>
